import { CALL_API } from '../../middleware/api'
import queryString from 'query-string'

// 已经结束流程
export const HISTORY_PROCESS_REQUEST = 'HISTORY_PROCESS_REQUEST';
export const HISTORY_PROCESS_SUCCESS = 'HISTORY_PROCESS_SUCCESS';
export const HISTORY_PROCESS_FAILURE = 'HISTORY_PROCESS_FAILURE';

// 根据流程定义Key获取任务节点
export const PROCESS_ACTIVITY_LIST_REQUEST = 'PROCESS_ACTIVITY_LIST_REQUEST';
export const PROCESS_ACTIVITY_LIST_SUCCESS = 'PROCESS_ACTIVITY_LIST_SUCCESS';
export const PROCESS_ACTIVITY_LIST_FAILURE = 'PROCESS_ACTIVITY_LIST_FAILURE';

export const PROCESS_DEFINITION_LIST_REQUEST = 'PROCESS_DEFINITION_LIST_REQUEST';
export const PROCESS_DEFINITION_LIST_SUCCESS = 'PROCESS_DEFINITION_LIST_SUCCESS';
export const PROCESS_DEFINITION_LIST_FAILURE = 'PROCESS_DEFINITION_LIST_FAILURE';


export function getProcessedApply(params) {
	return {
		[CALL_API]: {
			types: [HISTORY_PROCESS_REQUEST, HISTORY_PROCESS_SUCCESS, HISTORY_PROCESS_FAILURE],
			endpoint: `/workflow/history/my-process?` + queryString.stringify(params)
		}
	}
}

export function getProcesseActivityList(params) {
	return {
		[CALL_API]: {
			types: [PROCESS_ACTIVITY_LIST_REQUEST, PROCESS_ACTIVITY_LIST_SUCCESS, PROCESS_ACTIVITY_LIST_FAILURE],
			endpoint: 'workflow/process/activity-list',
			methods: 'GET',
			params
		}
	}
}

export function getProcesseDefinitionList() {
	return {
		[CALL_API]: {
			types: [PROCESS_DEFINITION_LIST_REQUEST, PROCESS_DEFINITION_LIST_SUCCESS, PROCESS_DEFINITION_LIST_FAILURE],
			endpoint: 'workflow/process/process-definitions-list',
			methods: 'GET'
		}
	}
}

export default (params) => {
	return (dispatch, getState) => {
		return dispatch(getProcessedApply(params));
	};
};


// WEBPACK FOOTER //
// ./src/action/workflow/process.js